import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';

const AppBreadcrumb = (props) => {

    const [search, setSearch] = useState('');
    const location = useLocation()
    const activeRoute = props.routes.filter(route => {
        return route.path != null && route.path.replace(/\s/g, '').toLowerCase() === location.pathname.toLowerCase().replace(/\s/g, '').slice(1)
    })
    let items;

    if (location.pathname === '/') {
        items = [{ label: '' }, { label: 'Dashboard' }]
    }
    else if (!activeRoute.length) {

    }
    else {
        items = [
            { label: activeRoute[0].parent },
            { label: activeRoute[0].label }
        ]
    }

    const isStatic = () => {
        return props.menuMode === 'static';
    }

    return (
        <div className="layout-breadcrumb-container">

            {(items == null || items.length === 0) && (
                <div onClick={() => {
                    window.history.back();

                }} style={{ marginLeft: 20, cursor: 'pointer' }} className="layout-breadcrumb-menu">
                    <i className="pi pi-arrow-left"></i>
                </div>
            )}

            {items != null && items.length > 0 && (
                <div className="layout-breadcrumb-left-items">
                    {isStatic() && <button className="menu-button p-link" onClick={props.onMenuButtonClick}>
                        <i className="pi pi-bars"></i>
                    </button>}

                    <BreadCrumb model={items} className="layout-breadcrumb" />
                </div>
            )}

        </div>
    )
}

export default AppBreadcrumb;
